var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('plus-button',_vm._b({on:{"click":function($event){return _vm.$emit('click', $event)}}},'plus-button',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.$t('group.header.join'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }